import React from "react";
import { Accordion, Button, Col, Row,Container } from "react-bootstrap";
import {Link} from 'react-router-dom';
import Slider from "react-slick";
import { ImageElement, MainHeader, MainFooter } from "../../components";

function Home() {
    const services = {
        dots: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 3,
        arrow:false,
        nav:false,
        slidesToScroll: 1,
        centerPadding: "165px",
        responsive: [
        {
            breakpoint: 1500,
            settings: {
            centerPadding: "40px",
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 1,
                centerPadding: "200px",
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                centerPadding: "120px",
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                centerPadding: "40px",
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                centerPadding: "20px",
            }
        }
        ]
        // dots: false,
        // infinite: true,
        // slidesToShow: 4,
        // slidesToScroll: 1,
        // navs:true,
        // responsive: [
        //     {
        //       breakpoint: 1200,
        //       settings: {
        //         slidesToShow: 3,
        //         slidesToScroll: 3
        //       }
        //     },
        //     {
        //       breakpoint: 991,
        //       settings: {
        //         slidesToShow: 2
        //       }
        //     },
        //     {
        //         breakpoint: 576,
        //         settings: {
        //           slidesToShow: 1
        //         }
        //       }
        //   ]
      };
    const text = ">>"
    return (
        <>
        <div className="homePage">
            <MainHeader/>
            <main className="bg-white" >
                {/* banner */}
                <section className="banner position-relative">
                    <div className="shape d-flex align-items-start justify-content-between">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <Container className="text-center">
                        <div className="banner_top">
                            <h1 className="font-bd">Modern & Prestigious</h1>
                            <h2 className="font-md"><span>Home</span> Service Solutions</h2>
                            <p>HVAC, Plumber, Electrician & Other On Demand Service For You</p>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to="/"> <ImageElement className="img-fluid" source="google-play.svg" /> </Link>
                                <Link to="/"> <ImageElement className="img-fluid" source="app-store.svg" /> </Link>
                            </div>
                        </div>
                        <div className="banner_bottom">
                            <Row>
                                <Col md={3} xs={6}>
                                    <div className="service position-relative">
                                        <ImageElement source="hvac.jpg" alt="HVAC" className="img-fluid w-100" />
                                        <h2>HVAC</h2>
                                    </div>
                                </Col>
                                <Col md={3} xs={6}>
                                    <div className="service position-relative">
                                        <ImageElement source="plumber.jpg" alt="Plumber" className="img-fluid w-100" />
                                        <h2>Plumber</h2>
                                    </div>
                                </Col>
                                <Col md={3} xs={6}>
                                    <div className="service position-relative">
                                        <ImageElement source="electrician.jpg" alt="Electrician" className="img-fluid w-100" />
                                        <h2>Electrician</h2>
                                    </div>
                                </Col>
                                <Col md={3} xs={6}>
                                    <div className="service position-relative">
                                        <ImageElement source="on-demand-services.jpg" alt="On-demand-services" className="img-fluid w-100" />
                                        <h2>Other On Demand Services</h2>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </section>
                {/* find your experts */}
                <section className="findExperts py-80 pt-xxl-0">
                    <Container>
                        <Row>
                            <Col md={6} xxl={7}>
                                <div className="findExperts_img position-relative">                           
                                    <ImageElement source="experts.jpg" className="img-fluid" alt="experts" />
                                </div>
                            </Col>
                            <Col md={6} xxl={5}>
                                <div className="findExperts_content">
                                    <h2>Find your <span className="font-sm">Experts.</span></h2>
                                    <p className="subTxt">With Tékhnē you will find the best Professionals in the area, whatever your needs.</p>
                                    <ul className="list-unstyled">
                                        <li>
                                            <h3 className="font-md">Be Efficient</h3>
                                            <p>We get to customers fast and provide energy-efficient equipment.</p>
                                        </li>
                                        <li>
                                            <h3 className="font-md">The Right Technicians</h3>
                                            <p>5 years’ experience in the field. Technically strong and can work on various types of equipment. Enjoys the trade.</p>
                                        </li>
                                        <li>
                                            <h3 className="font-md">No Gimmicks</h3>
                                            <p>Show up and Do the right thing. Smart customers know nothing is "Free".</p>
                                        </li>
                                    </ul>
                                    <div className="text-end">
                                        <Link to="/aboutus">Know more about us {text}</Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                {/* count */}
                <section className="count py-80">
                    <ul className="count_wrap list-inline mb-0 mx-auto d-sm-flex align-center justify-content-between">
                        <li className="text-center">
                            <label className="font-sm">80k</label>
                            <p className="mb-0">Active Customers</p>
                        </li>
                        <li className="text-center">
                            <label className="font-sm">4.8</label>
                            <p className="mb-0">Customers Ratings</p>
                        </li>
                        <li className="text-center">
                            <label className="font-sm">2k</label>
                            <p className="mb-0">Good Guys Service Provider</p>
                        </li>
                    </ul>
                </section>
                {/* how it works */}
                <section className="howitWorks position-relative py-80">
                    <Container className="position-relative">
                        <div className="text-center commonHeading">
                            <h2 className="font-md h45">It has never been easier to hire a <span>Professional!</span></h2>
                            <p>Get started with Good Guys and get your job done in just 3 easy steps.</p>
                        </div>
                        <div className="d-md-flex align-center justify-content-between">
                            <div className="howitWorks_step">
                                <div className="img text-center">
                                    <ImageElement source="step01.svg" alt="Location" className="img-fluid" />
                                </div>
                                <div className="howitWorks_step_caption d-md-flex align-md-content-center">
                                    <span className="number d-block font-bd">01</span>
                                    <div className="ms-md-3">
                                        <h3 className="font-md mb-0">Select your location</h3>
                                        <p className="mb-0 mt-xxl-3">Describe your needs with just a few clicks on our form options.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="howitWorks_step">
                                <div className="img text-center">
                                    <ImageElement source="step02.svg" alt="Service" className="img-fluid" />
                                </div>
                                <div className="howitWorks_step_caption d-md-flex align-md-content-center">
                                    <span className="number d-block font-bd">02</span>
                                    <div className="ms-md-3">
                                        <h3 className="font-md mb-0">Select your service</h3>
                                        <p className="mb-0 mt-xxl-3">A list of services meeting your criteria will be presented to you.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="howitWorks_step">
                                <div className="img text-center">
                                    <ImageElement source="step03.svg" alt="Service" className="img-fluid" />
                                </div>
                                <div className="howitWorks_step_caption d-md-flex align-md-content-center">
                                    <span className="number d-block font-bd">03</span>
                                    <div className="ms-md-3">
                                        <h3 className="font-md mb-0">Hire a pro & finish the job</h3>
                                        <p className="mb-0 mt-xxl-3">You can contact the professional that you liked the most, by phone or email.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </section>
                {/* professional */}
                <section className="professional d-flex align-items-center">
                    <Container>
                        <div className="text-center text-md-end">
                            <div className="d-inline-block text-md-start">
                                <h2 className="font-md text-white">Are you a <span>Professional!</span></h2>
                                <p className="font-md mb-4 text-white">Experienced and customer focused!</p>
                                <Link to="/technician" className="btn btn-primary d-inline-block" >Join The Team</Link>
                            </div>
                        </div>
                    </Container>
                </section>
                {/* faq */}
                <section className="faq py-80">
                    <Container>
                        <div className="text-center commonHeading">
                            <h2 className="h45 font-sm">FAQ's</h2>
                            <p>Don't take our word for it, here’s what others have to say.</p>
                        </div>
                        <div className="faq_wrap mx-auto">
                            <Accordion defaultActiveKey="1"  className="border-0 rounded-0">
                                <Accordion.Item className="rounded-0" eventKey="0">
                                    <Accordion.Header>How does the Good Guys Home Services App work? </Accordion.Header>
                                    <Accordion.Body>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                    minim veniam, quis nostrud exercitation.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item className="rounded-0" eventKey="1">
                                    <Accordion.Header>How often should I service my HVAC and plumbing system?</Accordion.Header>
                                    <Accordion.Body>
                                        We recommend a maintenance appointment for HVAC twice a year (once for heat, once for air conditioning). 
                                        For plumbing one visit a year will help to make sure you’re getting the most out of your system.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item className="rounded-0" eventKey="2">
                                    <Accordion.Header>What happens when I need a repair on a holiday or weekend?</Accordion.Header>
                                    <Accordion.Body>
                                        Aliquam eu rhoncus ipsum, vitae blandit nisl. Mauris imperdiet orci eu velit sagittis, id rhoncus velit fermentum. 
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item className="rounded-0" eventKey="3">
                                    <Accordion.Header>Do I have to enter my credit card in the App?</Accordion.Header>
                                    <Accordion.Body>
                                        Proin et nisl quam. Nulla facilisi. Etiam et augue sapien. Cras elementum leo vitae orci mollis sodales. Sed fermentum, orci eget iaculis tincidunt, tellus nisl dictum sem.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item className="rounded-0" eventKey="4">
                                    <Accordion.Header>Do you have liability insurance?</Accordion.Header>
                                    <Accordion.Body>
                                        Nunc bibendum, ex ut venenatis gravida, ligula justo sagittis nulla, et mollis risus nunc non eros. Sed venenatis elementum nisl ut varius. Praesent rutrum molestie malesuada.
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Container>
                </section>
                {/* about us */}
                <section className="aboutUs py-80">
                    <Container>
                        <div className="text-center commonHeading">
                            <h2 className="h45 font-md">What they say <span>About Us</span></h2>
                            <p>Don't take our word for it, here’s what others have to say.</p>
                            <div className="aboutUs_top">
                                <h3 className="mb-0 font-md">Over <span className="font-bd">2000 +</span> <b className="font-bd">Clients</b> and <b className="font-bd">Professionals</b> use Good Guys home services.</h3>
                            </div>
                        </div>
                        {/* <div className="aboutUs_wrap d-md-flex align-items-center mx-auto">

                                <div className="profileCard d-flex bg-white">
                                    <div className="flex-shrink-0">
                                        <ImageElement source="user01.png" className="rounded-circle" alt="User" />
                                    </div>
                                    <div className="profileCard_caption">
                                        <p className="font-lt">Finding new clients is not always easy.Good Guys offers a solution that savestime on business development SOS is ayoung and dynamic company, and a trustedpartner! I definitely recommend Good Guys
                                        to every professional!</p>
                                        <h3 className="font-md mb-0">David Waltson, Businessman</h3>
                                    </div>
                                </div>
                                <div className="profileCard d-flex bg-white">
                                    <div className="flex-shrink-0">
                                        <ImageElement source="user02.png" className="rounded-circle" alt="User" />
                                    </div>
                                    <div className="profileCard_caption">
                                        <p className="font-lt">The professionals I found on the site all had Excellent reviews. I definitely don’t regret my Choice because the meal was delicious!</p>
                                        <h3 className="font-md mb-0">Philip Louis, Sportsperson</h3>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </Container>
                    <Slider {...services}>   
                            <div className="profileCard d-sm-flex bg-white">
                                <div className="flex-shrink-0">
                                    <ImageElement source="user01.png" className="rounded-circle" alt="User" />
                                </div>
                                <div className="profileCard_caption">
                                    <p className="font-lt">Finding new clients is not always easy.Good Guys offers a solution that savestime on business development SOS is ayoung and dynamic company, and a trustedpartner! I definitely recommend Good Guys
                                    to every professional!</p>
                                    <h3 className="font-md mb-0">David Waltson, Businessman</h3>
                                </div>
                            </div>
                    
                            <div className="profileCard d-sm-flex bg-white">
                                <div className="flex-shrink-0">
                                    <ImageElement source="user01.png" className="rounded-circle" alt="User" />
                                </div>
                                <div className="profileCard_caption">
                                    <p className="font-lt">Finding new clients is not always easy.Good Guys offers a solution that savestime on business development SOS is ayoung and dynamic company, and a trustedpartner! I definitely recommend Good Guys
                                    to every professional!</p>
                                    <h3 className="font-md mb-0">David Waltson, Businessman</h3>
                                </div>
                            </div>
                    
                            <div className="profileCard d-sm-flex bg-white">
                                <div className="flex-shrink-0">
                                    <ImageElement source="user-5.png" className="rounded-circle" alt="User" />
                                </div>
                                <div className="profileCard_caption">
                                    <p className="font-lt">Finding new clients is not always easy.Good Guys offers a solution that savestime on business development SOS is ayoung and dynamic company, and a trustedpartner! I definitely recommend Good Guys
                                    to every professional!</p>
                                    <h3 className="font-md mb-0">David Waltson, Businessman</h3>
                                </div>
                            </div>
                    
                            <div className="profileCard d-sm-flex bg-white">
                                <div className="flex-shrink-0">
                                    <ImageElement source="user01.png" className="rounded-circle" alt="User" />
                                </div>
                                <div className="profileCard_caption">
                                    <p className="font-lt">Finding new clients is not always easy.Good Guys offers a solution that savestime on business development SOS is ayoung and dynamic company, and a trustedpartner! I definitely recommend Good Guys
                                    to every professional!</p>
                                    <h3 className="font-md mb-0">David Waltson, Businessman</h3>
                                </div>
                            </div>
                    
                            <div className="profileCard d-sm-flex bg-white">
                                <div className="flex-shrink-0">
                                    <ImageElement source="user-2.png" className="rounded-circle" alt="User" />
                                </div>
                                <div className="profileCard_caption">
                                    <p className="font-lt">Finding new clients is not always easy.Good Guys offers a solution that savestime on business development SOS is ayoung and dynamic company, and a trustedpartner! I definitely recommend Good Guys
                                    to every professional!</p>
                                    <h3 className="font-md mb-0">David Waltson, Businessman</h3>
                                </div>
                            </div>
                    
                            <div className="profileCard d-sm-flex bg-white">
                                <div className="flex-shrink-0">
                                    <ImageElement source="user-04.png" className="rounded-circle" alt="User" />
                                </div>
                                <div className="profileCard_caption">
                                    <p className="font-lt">The professionals I found on the site all had Excellent reviews. I definitely don’t regret my Choice because the meal was delicious!</p>
                                    <h3 className="font-md mb-0">Philip Louis, Sportsperson</h3>
                                </div>
                            </div>
                    </Slider>
                </section>
            </main>
            <MainFooter/>
        </div>
        </>        
    );
  }
  
  export default Home;